<template>
  <header class="header">
    <IconButton
      icon="back"
      view="outlined"
      theme="primary"
      class="header__back"
      :class="{ header__back_hidden: isBackHidden }"
      @click="$emit('back')"
    />
    <button
      type="button"
      class="header__logo"
      :disabled="isLogoDisabled"
      @click="$emit('home')"
    >
      <img :src="logo" alt="">
    </button>
  </header>
</template>

<script>
import IconButton from '@/components/IconButton.vue';
import logo from '@/assets/images/logo.png';

export default {
  name: 'TheHeader',
  components: {
    IconButton,
  },
  staticData: () => ({
    logo,
  }),
  computed: {
    isBackHidden() {
      return !this.$route.meta?.back;
    },
    isLogoDisabled() {
      return this.$route.name === 'Home';
    },
  },
};
</script>

<style lang="stylus">
.header
  display flex
  align-items center
  padding-left $side_padding
  padding-right @padding-left

  &__back
    pointer-events auto
    &_hidden
    .screen_header_hidden ~ .app__header &
      visibility hidden
    .screen_pending ~ .app__header &
      opacity 0.25
      pointer-events none

  &__logo
    display block
    //width 3.5em
    height 2.8em
    padding 0
    background none
    border 0
    outline none
    margin-left 1.5em
    transition transform 200ms
    pointer-events auto
    cursor pointer
    img
      display block
      height 100%
    &[disabled]
      pointer-events none
    &:active
      opacity 0.8
    .screen_header_hidden.screen_footer_hidden ~ .app__header &
    &_hidden
      opacity 0
    .screen_full ~ .app__header &
      display none
    .screen_header_hidden ~ .app__header &
    ~/__back_hidden ~ &
      transform translate(-4.5em, 0)
</style>
